import { Plus } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import clsx from "clsx";
import { Button, type ButtonProps } from "../Button/Button.js";
import { Icon } from "../Icon/Icon.js";
import styles from "./AddRow.module.scss";

export interface AddRowProps extends Omit<ButtonProps, "variant" | "size"> {
  /** Leading glyph. Defaults to `Plus`; an upload affordance passes `Upload`. */
  icon?: LucideIcon;
}

/**
 * The "+ Add <thing>" affordance under an editable list: a dashed pill that reads as the next,
 * not-yet-real row.
 *
 * It owns `align-self: flex-start` because every list it sits under is a column flex — without it the
 * button stretches the full card width and stops reading as a row-sized control. That one property
 * is the whole reason this is a component and not just `<Button variant="dashed">` at each site.
 */
export function AddRow({ icon = Plus, children, className, ...rest }: AddRowProps) {
  return (
    <Button variant="dashed" size="xs" className={clsx(styles.addRow, className)} {...rest}>
      <Icon icon={icon} size={16} />
      {children}
    </Button>
  );
}
